module.exports = __webpack_public_path__ + "7ff6332af869f79f19900f85233624a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cypher4.png
// module id = 1030
// module chunks = 0